/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Product_Type_Bo_HopInputs */

const vi_shop_product_type_bo_hop = /** @type {(inputs: Shop_Product_Type_Bo_HopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bộ hộp`)
};

/**

* @param {Shop_Product_Type_Bo_HopInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_product_type_bo_hop = /** @type {((inputs?: Shop_Product_Type_Bo_HopInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Product_Type_Bo_HopInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_product_type_bo_hop(inputs)
});